import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

const ReceptionistDashboardCards = ({ loading, dashboardStats }) => {
  // Stats for receptionist dashboard
  const stats = dashboardStats || {
    calls_today: 0,
    incoming_calls: 0,
    outgoing_calls: 0,
    pending_follow_ups: 0,
  };

  const metricItems = [
    {
      key: "calls_today",
      label: "Calls Today",
      value: stats.calls_today || stats.today_calls || 0,
      tone: "slate",
      chartHeights: [0.5, 0.7, 0.6, 0.8, 0.9],
    },
    {
      key: "incoming_calls",
      label: "Incoming Calls",
      value: stats.incoming_calls || 0,
      tone: "teal",
      chartHeights: [0.4, 0.6, 0.7, 0.5, 0.8],
    },
    {
      key: "outgoing_calls",
      label: "Outgoing Calls",
      value: stats.outgoing_calls || 0,
      tone: "coral",
      chartHeights: [0.6, 0.5, 0.8, 0.7, 0.6],
    },
    {
      key: "pending_follow_ups",
      label: "Follow-ups Pending",
      value: stats.pending_follow_ups || stats.pending || 0,
      tone: "mint",
      chartHeights: [0.7, 0.5, 0.4, 0.6, 0.5],
    },
  ];

  return (
    <GlobalMetricCards
      items={metricItems}
      loading={loading}
      skeletonCount={4}
      ariaLabel="Receptionist call logs statistics"
      gridClassName="gm-metrics-grid--quad"
    />
  );
};

export default ReceptionistDashboardCards;
